/* eslint-disable */
import $ from 'jquery';
import ko from 'knockout';
import _ from 'underscore';
import urlOptionsFields from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/urlOptionsFields';
import actionTypes from '@bingads-webui-static-legacy/bulk-edit/viewmodel/ad/actions';
import textActionTypes from '@bingads-webui-static-legacy/schema/bulkEdit/textActionType';
import Base from '@bingads-webui-static-legacy/bulk-edit/viewmodel/bulkEditJob';
import options from '@bingads-webui-static-legacy/schema/bulkEdit/textActionOptions';
import trackingTemplateActionTypes from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/trackingTemplateActions';
import customParametersActionTypes from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/customParametersActions';
import entityTextMessage from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/entityProgressText';
import globalConfig from '@bingads-webui-component-legacy/config/index';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var actionOptions = [{
  Value: actionTypes.set,
  Text: i18n.getString('BulkEdit_UrlOptions_SetTextOption')
}, {
  Value: actionTypes.findReplace,
  Text: i18n.getString('BulkEdit_UrlOptions_FindAndReplaceOption')
}, {
  Value: actionTypes.append,
  Text: i18n.getString('BulkEdit_UrlOptions_AppendTextOption')
}];
var trackingTemplateActionOptions = [{
  Value: trackingTemplateActionTypes.set,
  Text: i18n.getString('BulkEdit_UrlOptions_TrackingTemplate_Set')
}, {
  Value: trackingTemplateActionTypes.remove,
  Text: i18n.getString('BulkEdit_UrlOptions_TrackingTemplate_Remove')
}];
var customParametersActionOptions = [{
  Value: customParametersActionTypes.add,
  Text: i18n.getString('BulkEdit_UrlOptions_CustomParameters_Add')
}, {
  Value: customParametersActionTypes.replaceAll,
  Text: i18n.getString('BulkEdit_UrlOptions_CustomParameters_ReplaceAll')
}, {
  Value: customParametersActionTypes.removeExact,
  Text: i18n.getString('BulkEdit_UrlOptions_CustomParameters_RemoveExact')
}, {
  Value: customParametersActionTypes.removeContaining,
  Text: i18n.getString('BulkEdit_UrlOptions_CustomParameters_RemoveContaining')
}, {
  Value: customParametersActionTypes.removeAll,
  Text: i18n.getString('BulkEdit_UrlOptions_CustomParameters_RemoveAll')
}];
var fieldOptions = [{
  Value: urlOptionsFields.trackingTemplate,
  Text: i18n.getString('BulkEdit_UrlOptions_TrackingTemplate')
}, {
  Value: urlOptionsFields.finalUrlSuffix,
  Text: i18n.getString('BulkEdit_UrlOptions_FinalUrlSuffix')
}, {
  Value: urlOptionsFields.customParameters,
  Text: i18n.getString('BulkEdit_UrlOptions_CustomParameters')
}, {
  Value: urlOptionsFields.customParametersName,
  Text: i18n.getString('BulkEdit_UrlOptions_CustomParametersName')
}, {
  Value: urlOptionsFields.customParametersValue,
  Text: i18n.getString('BulkEdit_UrlOptions_CustomParametersValue')
}];
var ViewModel = function (model, options) {
  Base.call(this);
  var entity = model.get('Entity');
  var entityLowerCase = entity ? entity.toLowerCase() : '';
  var finalUrlSuffixEnabledEntities = ['campaign', 'adgroup', 'keyword', 'ad', 'audience'];
  var IsFinalURLSuffixEnabled = finalUrlSuffixEnabledEntities.indexOf(entityLowerCase) >= 0;
  this.entityType = options.entityType;
  this.actions = actionOptions;
  this.showExtaWarningMessage = options.showExtaWarningMessage;
  this.trackingTemplateActions = trackingTemplateActionOptions;
  this.customParametersActions = customParametersActionOptions;
  var fields = _.clone(fieldOptions);
  if (!IsFinalURLSuffixEnabled) {
    fields = _.filter(fieldOptions, function (opt) {
      return opt.Value !== urlOptionsFields.finalUrlSuffix;
    });
  }
  this.fields = fields;
  var action = model.get('BatchAction').Actions[0];
  this.selectedAction = ko.observable(action.ActionType);
  this.selectedField = ko.observable(action.Property);
  this.trackingTemplateSelectedAction = ko.observable(action.ActionType);
  this.customParametersSelectedAction = ko.observable(action.ActionType);
  this.showCustomParamsInput = ko.observable(true);
  this.showTrackingTemplateInput = ko.computed(function () {
    return this.trackingTemplateSelectedAction() === trackingTemplateActionTypes.set;
  }, this);
  this.selectedAction.subscribe(function () {
    this.errorMessage('');
  }, this);
  this.showFindReplacePanel = ko.computed(function () {
    return this.selectedAction() === actionTypes.findReplace;
  }, this);
  this.showAppendTextPanel = ko.computed(function () {
    return this.selectedAction() === actionTypes.append;
  }, this);
  this.showSetTextPanel = ko.computed(function () {
    return this.selectedAction() === actionTypes.set;
  }, this);
  this.showFinalUrlSuffixInput = ko.computed(function () {
    return IsFinalURLSuffixEnabled && this.showSetTextPanel();
  }, this);
  this.trackingTemplate = ko.observable('');
  this.finalUrlSuffix = ko.observable('');
  this.changeTextOption = ko.observable(textActionTypes.append);
  this.findTextValue = ko.observable(action.SearchString);
  this.findText = ko.computed({
    read: function () {
      return this.findTextValue();
    },
    write: function (value) {
      this.errorMessage('');
      this.findTextValue(value);
    },
    owner: this
  });
  this.findText.subscribe(function (value) {
    if (value.indexOf(' ') >= 0) {
      this.findReplaceOptions(_.without(this.findReplaceOptions, options.MatchWholeWord));
    }
  }, this);
  this.replaceText = ko.observable(action.Value);
  this.appendTextValue = ko.observable(action.Value);
  this.appendText = ko.computed({
    read: function () {
      return this.appendTextValue();
    },
    write: function (value) {
      this.errorMessage('');
      this.appendTextValue(value);
    },
    owner: this
  });
  this.findReplaceOptions = ko.observableArray([]);
  this.selectedEntityCount(model.get('selectedEntityCount'));
  this.titleText = ko.computed(function () {
    switch (this.entityType) {
      case 'Ad':
        return i18n.getString('BulkEdit_UrlOptions_Ad_Title').replace('{0}', this.selectedEntityCount());
        break;
      case 'Keyword':
        return i18n.getString('BulkEdit_UrlOptions_Keyword_Title').replace('{0}', this.selectedEntityCount());
        break;
      case 'AdGroup':
        return i18n.getString('BulkEdit_UrlOptions_AdGroup_Title').replace('{0}', this.selectedEntityCount());
        break;
      case 'Campaign':
        return i18n.getString('BulkEdit_UrlOptions_Campaign_Title').replace('{0}', this.selectedEntityCount());
        break;
    }
  }, this);
  this.maxTrackingTemplateLength = 2048;
  this.maxFinalUrlSuffixLength = 1024;
  this.maxCustomParametersLength = 16;
  this.maxCustomParametersKeyLength = 16;
  this.maxCustomParametersValueLength = 200;
  this.maxLength = ko.computed(function () {
    var field = this.selectedField();
    switch (field) {
      case urlOptionsFields.trackingTemplate:
        return this.maxTrackingTemplateLength;
        break;
      case urlOptionsFields.finalUrlSuffix:
        return this.maxFinalUrlSuffixLength;
        break;
      case urlOptionsFields.customParameters:
        return this.maxCustomParametersLength;
        break;
      case urlOptionsFields.customParametersName:
        return this.maxCustomParametersKeyLength;
        break;
      case urlOptionsFields.customParametersValue:
        return this.maxCustomParametersValueLength;
        break;
    }
    return 32;
  }, this);
  this.errorRole = ko.computed(function () {
    var error = this.errorMessage();
    return error === '' ? 'none' : 'alert';
  }, this);
  this.entityHeaderName = ko.computed(function () {
    switch (this.entityType) {
      case 'Ad':
        return i18n.getString('BulkEdit_Ad_EntityNameHeader');
        break;
      case 'Keyword':
        return i18n.getString('BulkEdit_Keyword_EntityNameHeader');
        break;
      case 'AdGroup':
        return i18n.getString('BulkEdit_AdGroup_EntityNameHeader');
        break;
      case 'Campaign':
        return i18n.getString('BulkEdit_Campaign_EntityNameHeader');
        break;
      default:
        return 'unknown entity';
        break;
    }
  }, this);
  this.previewGrids = ko.observableArray([]);
  this.errorsGrids = ko.observableArray([]);
  this.showPreview = ko.observable(false);
  this.validate = function (view) {
    this.errorMessage('');
    if (this.selectedEntityCount() === 0) {
      alert(i18n.getString('Grid_RowSelectionRequired'));
      return false;
    }
    var action = this.selectedAction();
    if (action === actionTypes.findReplace) {
      if (this.findText() === '' || this.findText() === null) {
        this.errorMessage(i18n.getString('BulkEdit_EmptyFindTextError'));
        return false;
      }
    } else if (action === actionTypes.append) {
      if (this.appendText() === '' || this.appendText() === null) {
        this.errorMessage(i18n.getString('BulkEdit_EmptyAppendTextError'));
        return false;
      }
    } else if (action === actionTypes.set) {
      if (this.trackingTemplateSelectedAction() === trackingTemplateActionTypes.set && (this.trackingTemplate() === null || this.trackingTemplate().trim() === '') && (this.finalUrlSuffix() === null || this.finalUrlSuffix().trim() === '') && this.customParametersSelectedAction() !== customParametersActionTypes.removeAll && view.customParams.getValues(true).params.length === 0) {
        this.errorMessage(i18n.getString(entityTextMessage[entity].EmptySetTextError));
        return false;
      }
    }
    return true;
  };
};
export default ViewModel;

